import { useState, useCallback } from 'react';
import useToastNotification from 'hooks/useToastNotification';
import { Error, importCSVFileToBudgetDailyInput, importCSVFileToBudgetYearInput } from 'api/salesBudgetYear';

export const useSaleBudgetImport = () => {
  const [uploadFile, setUploadFile] = useState<File>();
  const [errors, setErrors] = useState<Array<string>>();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [inputValue, setValueInput] = useState('');
  const { successNotification, errorNotification } = useToastNotification();
  const [blocking, setBlocking] = useState(false);

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const extensionFile = (name: string) => name.split('.').pop();

  if (uploadFile) {
    const fileType = extensionFile(uploadFile.name);
    if (fileType !== 'csv') {
      errorNotification('CSVファイルを選択してください。');
      setUploadFile(undefined);
      setValueInput('');
    }
  }

  const onSubmit = useCallback(
    (data: { inputType: string }) => {
      setBlocking(true);
      if (!uploadFile) {
        errorNotification('ファイルを選択してください');

        return;
      }
      setErrors(undefined);

      const targetYear = `${sessionStorage.getItem('dateSelect')}/01/01`;
      const orgCode = sessionStorage.getItem('orgCode_DestinationOrg') || 'all';
      setConfirmModalOpen(false);

      if (data.inputType === '0') {
        importCSVFileToBudgetYearInput(uploadFile)
          .then((response: any) => {
            setBlocking(false);
            if (response.status && response.status !== 200) {
              setErrors((response.data.errors as Array<Error>).map((err) => err.defaultMessage));
            } else {
              successNotification('インポートが完了しました。');
              // インポート完了後にファイルをリセット
              setUploadFile(undefined);
              setErrors(undefined);
            }
          })
          .catch((error: any) => {
            setBlocking(false);
            if (error.response && error.response.data && error.response.data.errors) {
              setErrors((error.response.data.errors as Array<Error>).map((err) => err.defaultMessage));
            } else {
              errorNotification('サーバー側でエラーが発生しました。');
            }
          });
      } else if (data.inputType === '1') {
        importCSVFileToBudgetDailyInput(uploadFile)
          .then((response: any) => {
            setBlocking(false);
            if (response.status && response.status !== 200) {
              setErrors((response.data.errors as Array<Error>).map((err) => err.defaultMessage));
            } else {
              successNotification('インポートが完了しました。');
              // インポート完了後にファイルをリセット
              setUploadFile(undefined);
              setErrors(undefined);
            }
          })
          .catch((error: any) => {
            setBlocking(false);
            if (error.response && error.response.data && error.response.data.errors) {
              setErrors((error.response.data.errors as Array<Error>).map((err) => err.defaultMessage));
            } else {
              errorNotification('サーバー側でエラーが発生しました。');
            }
          });
      }
    },
    [errorNotification, successNotification, uploadFile],
  );

  const handleSubmit = useCallback(() => {
    setConfirmModalOpen(true);
  }, []);

  return {
    setUploadFile,
    uploadFile,
    onSubmit,
    errors,
    confirmModalOpen,
    closeConfirmModal,
    inputValue,
    handleSubmit,
    blocking,
  };
};
export default useSaleBudgetImport;
